export default {
  button: {
    add: '追加',
    back: '戻る',
    cancel: 'キャンセル',
    close: '閉じる',
    create: '作成',
    createAccount: '新しいアカウントの作成',
    delete: '削除',
    edit: '編集',
    logout: 'ログアウト',
    ok: 'OK',
    save: '保存',
    sendResetEmail: 'リセットメールアドレスを送信する',
    signup: '登録する',
    forgotPassword: 'パスワードをお忘れですか',
    signin: 'サインイン',
    resetPassword: 'パスcワードの再設定',
    submit: '送信',
    copy: 'コピー',
  },
  error: {
    appUpdateClientCredential:
      'アプリケーションにすでにユーザーが存在しているるため、クライアントの認証タイプを更新できません',
    changePasswordUnsuccess: 'パスワードの変更に失敗しました。',
    create: '{name}の作成に失敗しました。',
    currentPassNotMatch: '現在のパスワードが一致しません。',
    destroy: '{name}の削除に失敗しました。',
    emailWasUsed: 'メールアドレスは使用されています。',
    exist: '{name}はすでに存在しています',
    expire: '{name}は有効期限切れです',
    forgotPasswordUnsuccess: 'パスワードリセットに失敗しました',
    hasMany: '{field}は既に{another_field}を持っています',
    lessThan: '{field}は{another_field}より少ない必要があります',
    list: 'リスト{name}の取得に失敗しました。',
    notExist: '{field}は存在しません',
    notFound: '見つかりません',
    notPermission: '許可がありません',
    resetPasswordUnsuccess: 'パスワードのリセットに失敗しました。',
    sessionTimeout: 'セッションがタイムアウトしました。 もう一度ログインしてください。',
    update: '{name}の更新に失敗しました。',
    updateProfileUnsuccess: 'プロファイルの更新に失敗しました。',
    used: '{name}は使用されています',
    wrongEmailPassword: 'メールアドレスまたはパスワードが一致しません。',
    lockedAccount: 'Your account is locked. Please contact with system administrator to unlock.',
    accessToken: 'アクセストークンの取得に失敗しました。',
    loginAuthorizationFail: 'ログインできませんでした。',
    notCopyToken: 'アクセストークンがコピーできません。',
    deletedUser: 'あなたのアカウントは削除されました。 管理者に連絡してください。',
    verifyToken: 'トークンが無効です。',
    copyDecodeFail: 'デコードされたトークンがコピーできません。',
    expiredResetPassword:
      'パスワードリセットのリンクの有効期限が切れています。 リセットを再度お試し\nください。',
    appHasClient: 'このアプリケーションにはクライアントが存在しています',
  },
  header: {
    application: 'アプリケーション',
    configApplication: '設定',
    createApp: 'アプリケーションの作成',
    createProfile: 'プロフィールを作成',
    dashboard: 'ダッシュボード',
    division: 'Suites',
    editApp: 'アプリケーションを編集',
    endUser: 'アプリケーションユーザー',
    forgotPassword: 'パスワードをお忘れですか？',
    general: '一般',
    login: 'アカウントにログイン',
    project: 'プロジェクト',
    resetPassword: 'パスcワードの再設定',
    setting: '設定',
    signin: 'サインイン',
    user: 'ユーザー',
    tutorial: 'チュートリアル',
    genToken: 'トークンの生成',
    loginAuthorization: 'ログイン',
    verifyToken: 'トークンの確認',
    decodedToken: 'デコードされたトークン',
    accessToken: 'アクセストークン',
    client: 'クライアント',
    createClient: 'クライアントの作成',
    editClient: 'クライアントの編集',
  },
  label: {
    project: 'プロジェクト',
    division: 'Suite',
    user: 'ユーザー',
    application: 'アプリケーション',
    configApplication: '設定',
    accessTokenLifeSpan: 'アクセストークンの有効期限',
    authenticatorType: '認証タイプ',
    changePassword: 'パスワードを変更',
    clientId: 'クライアントID',
    clientSecret: 'クライアントシークレット',
    company: '会社',
    confirmNewPassword: '新しいパスワードを確認する',
    confirmPassword: 'パスワードの確認',
    copyright: 'Copyright © 2020 トランスコスモス株式会社 All rights reserved.',
    createApp: 'アプリケーションを作成',
    createDivision: 'Create Suite',
    createEndUser: 'アプリケーションユーザーの作成',
    createProject: 'プロジェクトを作成',
    createUser: 'ユーザーの作成',
    currentPassword: '現在のパスワード',
    divisionAdmin: 'Suite Admin',
    editApp: 'アプリケーションの編集',
    editDivision: 'Edit Suite',
    editEndUser: 'アプリケーションユーザーを編集する',
    editProject: 'プロジェクトの編集',
    editUser: 'ユーザーの編集',
    email: 'Eメール',
    endUser: 'アプリケーションユーザー',
    errorLogs: '失敗した処理のログ',
    errorLogsInThisWeek: '今週失敗した処理のログ',
    examples: '例',
    firstName: '名',
    id: 'ID',
    idAccessTokenLifeSpan: 'アクセストークンの有効期限(分)のID',
    lastName: '姓',
    logStatistics: 'ログ統計',
    name: '名前',
    newPassword: '新しいパスワード',
    note: '備考',
    password: 'パスワード',
    redirectUrl: 'URLのリダイレクト',
    refreshTokenLifeSpan: 'アクセストークンの有効期限を更新',
    region: '地域',
    role: '権限',
    scopeName: 'スコープ名',
    scopes: 'スコープ',
    successLogs: '成功した処理のログ',
    successLogsInThisWeek: '今週成功した処理のログ',
    superAdmin: 'Super Admin',
    systemUser: 'システムユーザー',
    minutes: '分',
    times: '回数',
    totalLogsInThisWeek: '今週のログの合計',
    url: 'URL',
    whitelist: 'ホワイトリストパブリックIP/ドメイン',
    yourProfile: 'プロフィール',
    publicIp: 'パブリックIP',
    domain: 'ドメイン',
    status: 'ステータス',
    codeChallenge: 'コードチャレンジ',
    codeChallengeMethod: 'コードチャレンジ方法',
    codeVerifier: 'コードベリファイア',
    code: 'コード',
    accessToken: 'アクセストークン',
    client: 'クライアント',
  },
  message: {
    acceptHttps: 'httpsのみを許可',
    alreadyHaveAccount: 'すでにログインIDとパスワードを所有しています',
    changePasswordSuccess: 'パスワードの変更に成功しました。',
    create: '{name}の作成に成功しました。',
    delete: '削除してもよろしいですか？',
    destroy: '{name}の削除に成功しました。',
    forgotPasswordSuccess:
      'パスワードをリセットするためのリンクは、Eメールを確認してください。数分以内に受信されない場合は、スパムフォルダを確認してください。',
    list: 'リスト{name}の取得に成功しました。',
    noData: 'データが存在しません',
    noRecordFound: 'レコードが見つかりません',
    noteWhitelist:
      'すべてのホワイトリスト(IPアドレスやドメイン)を許可する場合「*」を入力して下さい。',
    resetPasswordSuccess: 'パスワードのリセットに成功しました。',
    update: '{name}の更新に成功しました。',
    updateProfileSuccess: 'プロフィールの更新に成功しました。',
    easyManagement: '管理をもっと効率的に！',
    resetPassword: 'パスワードをリセットしますか。',
    copySuccess: 'アクセストークンをコピーします。',
    copyDecodeSuccess: 'デコードされたトークンをコピーします。',
  },
  paging: {
    next: '次へ',
    prev: '前へ',
    records: 'レコード',
    rows: '{rows} 行',
  },
  placeholder: {
    inputConfirmNewPassword: '新しい確認用パスワードを入力してください',
    inputConfirmPassword: '確認用パスワードを入力してください',
    inputCurrentPassword: '現在のパスワードを入力してください',
    inputEmail: 'メールアドレスを入力してください',
    inputFirstName: '名を入力してください',
    inputLastName: '姓を入力してください',
    inputName: '{name}を入力してください',
    inputNewPassword: '新しいパスワードを入力してください',
    inputFieldName: 'を入力してください',
    inputPassword: 'パスワードを入力してください',
    inputRedirectUrl: 'リダイレクトURLを入力してください',
    inputScope: 'スコープ名を入力してください',
    inputWhiteList: 'パブリックIP/ドメインを入力してください',
    searchCompany: '会社を選択してください',
    searchRegion: '地域を選択してください',
    selectApplication: 'アプリケーションを選択してください',
    selectAuthenticatorType: '認証タイプを選択してください',
    selectDivision: 'Please select suite',
    selectProject: 'プロジェクトを選択してください',
    inputCodeChallenge: 'コードチャレンジを入力下さい',
    inputCodeChallengeMethod: 'コードチャレンジ方法を入力下さい',
    inputCodeVerifier: 'コードベリファイアを入力して下さい',
  },
  title: 'ATM',
  validation: {
    confirmPass: 'パスワードと確認用パスワードが一致しません',
    email: {
      format: 'メールアドレスを正しく入力してください',
    },
    incorrect: '{field}が正しくありません',
    max: '{field}は{max}文字未満である必要があります',
    min: '{field}は最低{min}文字必要です',
    passwordRule: 'パスワードには、アルファベット（A-Z）の大文字が少なくとも1つ必要です。',
    positive: '{field}は正数である必要があります',
    required: '{field}は必須です',
    timeLifeSpanRefreshToken: '期限は0より大きい必要があります',
    timeLifeSpanAccessToken: '入力する時間値は 0 より大きく 601 未満である必要があります',
  },
}
